import { Text, colors } from '@soluto-private/mx-asurion-ui-react';

type TextProps = {
  children?: React.ReactNode;
  className?: string;
};

export const PrimaryText = ({ children, className }: TextProps) => (
  <Text as="p" className={className} size={2}>
    {children}
  </Text>
);

export const SecondaryText = ({ children, className }: TextProps) => (
  <Text as="span" className={className} color={colors.neutralDeepest} size={1}>
    {children}
  </Text>
);
